module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "wind-speed"
  }, _vm._l((_vm.visualizationWindSpeeds), function(windSpeed, index) {
    return _c('g', {
      key: index,
      attrs: {
        "transform": ("translate(" + (windSpeed.positionX) + " -" + (windSpeed.positionY) + ")")
      }
    }, [_c('use', {
      attrs: {
        "x": "-2",
        "y": "-2",
        "width": "4",
        "height": "4",
        "xlink:href": ("#wind-volume" + (_vm.level(windSpeed.windSpeed)))
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fc18eec","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/layer/wind_speed.vue
// module id = 900
// module chunks = 0